/**
 * Job Status Enums
 * Using Object.freeze() pattern for type-safe enums
 */

export const JobStatusEnum = Object.freeze({
  Pending: 'pending' as const,
  Processing: 'processing' as const,
  Completed: 'completed' as const,
  Failed: 'failed' as const,
});

export const QuestionStatusEnum = Object.freeze({
  Processing: 'processing' as const,
  Passed: 'passed' as const,
  Failed: 'failed' as const,
  PendingGraphics: 'pending_graphics' as const,
  Published: 'published' as const,
});

export const JobDownloadStatusEnum = Object.freeze({
  Successed: 'successed' as const,
  Failed: 'failed' as const,
  All: 'all' as const,
  PendingGraphics: 'pending-graphics' as const,
  Published: 'published' as const,
});

export const JobTypeEnum = Object.freeze({
  Create: 'create' as const,
  Update: 'update' as const,
});


export type JobStatus = typeof JobStatusEnum[keyof typeof JobStatusEnum];
export type QuestionStatus = typeof QuestionStatusEnum[keyof typeof QuestionStatusEnum];
export type JobDownloadStatus = typeof JobDownloadStatusEnum[keyof typeof JobDownloadStatusEnum];
export type JobType = typeof JobTypeEnum[keyof typeof JobTypeEnum];

